/* unplugin-vue-components disabled */import script from "./SellPointAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./SellPointAudit.vue?vue&type=script&setup=true&lang=js"

import "./SellPointAudit.vue?vue&type=style&index=0&id=cbc7f7e0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbc7f7e0"]])

export default __exports__